import { render, staticRenderFns } from "./AdminInsentifView.vue?vue&type=template&id=bf58b466&scoped=true"
import script from "./AdminInsentifView.vue?vue&type=script&lang=js"
export * from "./AdminInsentifView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf58b466",
  null
  
)

export default component.exports